"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mount = exports.default = void 0;

require("react-app-polyfill/ie11");

require("react-app-polyfill/stable");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _App = _interopRequireDefault(require("./App"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = _App.default;
/**
 * 
 * @param {string} id Идентификатор блока, куда вставляем калькулятор
 * @param {string} anchor Якорь, куда проматываем по нажатию кнопки 
 * @param {boolean} isPaymentDisabled Булево значение, определяющее, отключено ли поле "Средняя зарплата"
 * @param {boolean} showKppBudget Булево знаечние, ноебязательный параметр, если true - показывает поле бюджет кпп
 * @param {boolean} showButton Булево значение, необязательный параметр, если true. показывает кнопку
 * @param {(data: TCalcResult) => void} getValues Необязательный параметр, используется для получения доступа к значениям калькулятора извне
 */

exports.default = _default;

var mount = function mount(id, anchor, isPaymentDisabled, isLanding, antikrizis, customResultButton, showKppBudget, showButton, getValues) {
  if (id) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_react.default.StrictMode, null, /*#__PURE__*/_react.default.createElement(_App.default, {
      anchor: anchor,
      isPaymentDisabled: isPaymentDisabled,
      isLanding: isLanding,
      antikrizis: antikrizis,
      showKppBudget: showKppBudget,
      showButton: showButton,
      getValues: getValues,
      customResultButton: customResultButton
    })), document.getElementById(id));
  }
};

exports.mount = mount;

if (typeof window !== "undefined" && typeof document !== "undefined") {
  var defaultNode = document.getElementById('npfsb-corporate-calc');

  if (defaultNode) {
    mount('npfsb-corporate-calc', 'test', true, false, false, undefined, false, false);
  }
} // If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();